import type { FaqEntry } from '../../types';

interface Props {
  entry: FaqEntry;
}

export default function FaqItem({ entry }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <p className="typography-product-subheading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        {entry.question}
      </p>
      <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {entry.answer}
      </p>
    </div>
  );
}
